<template>
  <v-card>
    <v-card-title>{{ test.name }}</v-card-title>
    <!-- <v-card-subtitle>
      You scored {{ userTest.score }} and needed {{ test.passingScore }} to
      pass</v-card-subtitle
    > -->
    <v-card-text>
      <v-row>
        <v-col>
          <h1 v-if="userTest.passed" class="secondary--text">PASSED</h1>
          <h1 v-else class="primary--text">FAILED</h1>
          <div v-if="failedQs">
            <h3 class="primary--text">
              Questions you got wrong: {{ failedQs }}
            </h3>
            <div v-for="item in userAnswers" :key="item.id">
              <h3>
                {{ item.answerQuestionQuestionText }}
              </h3>
              <h3 class="secondary--text">
                You answered: {{ item.answerAnswerText }}
              </h3>
              <v-divider></v-divider>
            </div>
          </div>
        </v-col>
        <v-col>
          <video
            v-if="test.videoId"
            :src="video"
            controls
            playsinline
            preload="none"
            width="100%"
            name="videoPlayer"
            :poster="image"
          ></video>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            v-if="userTest.passed"
            @click="viewCertificate"
            color="success darken-2"
            width="100%"
          >
            Download Passed Certificate PDF
          </v-btn>
        </v-col>
        <v-col>
          <test-document-table
            :readOnly="true"
            :testId="userTest.testId"
          ></test-document-table>
        </v-col>
      </v-row>
      <v-btn width="100%" color="primary darken-2" @click="navigate"
        >Continue
      </v-btn>
    </v-card-text>
  </v-card>
  <!-- Answer Component -->
</template>

<script>
import UserTestService from "@/services/UserTestService.js";
import UserAnswerService from "@/services/UserAnswerService.js";
import AnswerService from "@/services/AnswerService.js";
import TestService from "@/services/TestService.js";
import ApiService from "@/services/ApiService.js";
import TestDocumentTable from "@/components/tables/TestDocumentTable.vue";

export default {
  name: "Results",
  components: { TestDocumentTable },
  data() {
    return {
      loading: false,
      answers: [],
      questions: [],
      test: {},
      userTest: {},
      userAnswers: []
    };
  },
  created() {
    this.getUserTest().then(() => {
      this.getTest(),
        this.getWrongUserAnswers().then(() => {
          this.getCorrectAnswers();
        });
    });
  },
  computed: {
    video() {
      return `${ApiService.getBaseUrl()}test/video/${this.test.videoId}`;
    },
    docs() {
      return `${ApiService.getBaseUrl()}test/docs/${
        this.test.additionalDocsId
      }`;
    },
    image() {
      return `${ApiService.getBaseUrl()}test/thumbnail/${
        this.test.thumbnailId
      }`;
    },
    failedQs() {
      return this.userAnswers.length;
    }
  },
  methods: {
    async getUserTest() {
      this.userTest = await UserTestService.getUserTest(
        this.$route.params.userTestId
      );
    },
    async getWrongUserAnswers() {
      this.userAnswers = await UserAnswerService.getWrongByTestId(
        this.userTest.testId,
        this.userTest.userTestId
      );
    },
    async getTest() {
      this.test = await TestService.getTest(this.userTest.testId);
    },
    async getCorrectAnswers() {
      this.userAnswers.forEach(async element => {
        this.answers.push(await this.correctAnswer(element.answerQuestionId));
      });
    },
    async viewCertificate() {
      try {
        const file = await UserTestService.getCert(this.userTest.userTestId);
        const url = window.URL.createObjectURL(
          new Blob([file], { type: file.type })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = "Certificate.pdf";
        document.body.appendChild(link);
        link.click();
      } catch {
        this.$snackbarError("Fail");
      }
    },
    navigate() {
      this.$router.push({ name: "SelectTest" });
    },
    additionalDocs() {
      window.open(this.docs);
    },
    async correctAnswer(questionId) {
      const answer = await AnswerService.getCorrectByQuestionId(questionId);
      return answer;
    },
    showCorrectAnswer(questionId) {
      return this.answers.find(answer => answer.questionId == questionId)
        .answerText;
    }
  }
};
</script>
